import { render, staticRenderFns } from "./InvoiceRules.vue?vue&type=template&id=6bf8f0ae"
import script from "./InvoiceRules.vue?vue&type=script&lang=ts"
export * from "./InvoiceRules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports